import React from "react"
import type { PaginationMeta } from "../../Questions/types"
import type { BookmarkCardViewModel } from "../types"
import BookmarkCard from "./BookmarkCard"
import "./BookmarksList.style.scss"

interface BookmarksListProps {
  cards: BookmarkCardViewModel[]
  pagination: PaginationMeta | null
  loading: boolean
  removingId: string | null
  selectedId?: string | null
  onPageChange: (page: number) => void
  onOpen: (questionId: string) => void
  onRemove: (questionId: string) => void
}

const BookmarksList = ({
  cards,
  pagination,
  loading,
  removingId,
  selectedId,
  onPageChange,
  onOpen,
  onRemove,
}: BookmarksListProps) => {
  const totalPages = Math.max(pagination?.total_pages || 1, 1)
  const currentPage = pagination?.page || 1
  const showPager = Boolean(pagination && pagination.total > pagination.per_page)

  return (
    <div className="bookmarks-list">
      <div className={`bookmarks-list__stack ${loading ? "is-fetching" : ""}`}>
        {cards.map((card) => (
          <BookmarkCard
            key={card.id}
            card={card}
            removing={removingId === card.id}
            selected={selectedId === card.id}
            onOpen={() => onOpen(card.id)}
            onRemove={() => onRemove(card.id)}
          />
        ))}
      </div>

      {showPager && (
        <div className="bookmarks-list__pagination">
          <button
            type="button"
            disabled={currentPage <= 1 || loading}
            onClick={() => onPageChange(Math.max(1, currentPage - 1))}
          >
            Previous
          </button>
          <span>
            Page {currentPage} of {totalPages}
            {pagination && pagination.total > 0
              ? ` · ${pagination.total} total`
              : ""}
          </span>
          <button
            type="button"
            disabled={currentPage >= totalPages || loading}
            onClick={() => onPageChange(currentPage + 1)}
          >
            Next
          </button>
        </div>
      )}
    </div>
  )
}

export default BookmarksList
